import { Box } from '@mui/material';
import {
  StyledDescription,
  StyledLink,
  StyledSection,
  StyledTitle,
} from '../AiKnowledgeManagementSolutions.styles';
import { costOfInformationChaosData } from './CosOfInformationChaos.data';
import {
  CostOfInformationChaosWrapper,
  CostOfInformationChaosRowWrapper,
  CostOfInformationChaosPoint,
} from './CostOfInformationChaos.styles';

export const CostOfInformationChaos = () => {
  return (
    <StyledSection width="small">
      <StyledTitle variant="display_sm">
        The Hidden Cost of Information Chaos
      </StyledTitle>
      <Box>
        <StyledDescription variant="regular_500">
          Your enterprise sits on a goldmine of organizational knowledge - years
          of documentation, expertise, processes, and insights scattered across
          SharePoint, Confluence, Google Drive, Slack, email, and countless
          other systems. Yet when your teams need critical information, they're
          left digging through digital haystacks, wasting hours that should be
          spent creating value.
        </StyledDescription>
      </Box>
      <Box mt={4}>
        <StyledDescription variant="regular_500">
          Let's look at the numbers: 50% of business decisions are made based on
          gut feel rather than data{' '}
          <StyledLink
            target="_blank"
            rel="noreferrer"
            href="https://barc.com/decision-making-no-information/">
            (source)
          </StyledLink>
          , primarily because the relevant information simply isn't available
          when needed. Even worse, workers spend 30% of their workday (12 hours
          per week) searching for information{' '}
          <StyledLink
            target="_blank"
            rel="noreferrer"
            href="https://www.ibm.com/support/pages/cognitive-university-watson-systems-smartseller">
            (source)
          </StyledLink>
          . That's 12 hours per week per employee, burning through productivity
          and frustrating your top talent.
        </StyledDescription>
      </Box>
      <Box mt={4}>
        <StyledDescription variant="regular_500">
          Generic off-the-shelf AI data management tools promise easy answers,
          but they fall short when facing:
        </StyledDescription>
        <CostOfInformationChaosWrapper>
          {costOfInformationChaosData.map((technology, index) => (
            <CostOfInformationChaosRowWrapper
              key={`firstColumn-technology-${index}`}>
              <CostOfInformationChaosPoint />
              <StyledDescription variant="regular_400">
                {technology}
              </StyledDescription>
            </CostOfInformationChaosRowWrapper>
          ))}
        </CostOfInformationChaosWrapper>
      </Box>
    </StyledSection>
  );
};
